<template>
  <v-row justify="center">
    <v-dialog v-model="$store.state.TransferFilterDialogForGeneralBasket" persistent width="1024">
      <v-card>
        <v-card-title>
          <span class="text-h5"> فلتر تحويل الطلب الى السله العامه</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" v-if="show_move_reason">
                <v-card-title> سبب التحويل </v-card-title>
                <v-card-text>
                  <v-textarea
                    :error="move_reason_required"
                    :error-messages="error_msgs"
                    auto-grow
                    variant="outlined"
                    rows="3"
                    row-height="25"
                    v-model="move_reason"
                    color="#000"
                    filled
                ></v-textarea>
              </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error blue-darken-1"
            variant="text"
            @click="closeDialog"
          >
            الغاء
          </v-btn>
          <v-btn color="primary blue-darken-1" variant="text" @click="handleTransferToGeneralBasket">
            تحويل ({{ getSelectedCount }})
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="active"
      :color="color"
      timeout="-1"
      right
      bottom
      class="ml-4"
      elevation="24"
      transition="fade-transition"
    >
      <div>
        <span class="font-weight-bold" style="font-size: 16px">{{ message }}</span>
      </div>
      <template v-slot:action>
        <v-btn icon small @click="active = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>
import { axiosInstance } from "@/axios/config";
import { EventBus } from '@/mixins/eventBus.js';

export default {
  name: "TransferFilterDialogForGeneralBasket",
  props: {
    "selectedItems":{
      required: false,
      default: () => []
    }, 
    "type" : {
      required: false
    }, 
    "req_itemKey": {
      default: 'id'
    }
  },
  data() {
    return {
      move_reason_required: false,
      error_msgs: [],
      show_move_reason: true,
      active: false,
      move_reason: "",
      message: "",
      color: "",
    };
  },
  computed: {
    getSelectedCount() {
      const selectedCount = this.selectedItems ? this.selectedItems.length : 0;
      const startElementCount = this.$store.state.startElement ? this.$store.state.startElement.length : 0;
      return selectedCount + startElementCount;
    }
  },
  watch: {
    move_reason(val) {
      if (val && val.trim().length > 0) {
        this.move_reason_required = false;
        this.error_msgs = [];
      } else {
        this.move_reason_required = false;
      }
    },
    "$store.state.TransferFilterDialogForGeneralBasket": {
      handler(val) {
        if (!val) {
          this.resetForm();
        }
      }
    },
  },
  mounted() {
    if (window.location.pathname === "/admin/requests/need-to-turn-new") {
      this.show_move_reason = false;
    } else {
      this.show_move_reason = true;
    }
  },
  methods: {
    closeDialog() {
      this.$store.state.TransferFilterDialogForGeneralBasket = false;
      this.resetForm();
    },
    resetForm() {
      this.move_reason = "";
      this.move_reason_required = false;
      this.error_msgs = [];
      this.active = false;
    },
    handleTransferToGeneralBasket() {
      this.$store.state.TransferFilterDialogForGeneralBasket = false;
      let body = new FormData();
      let url = `/v2/employee/Requests/moveSelectedRequestsToGeneralBasket`;
      
      body.append(`move_reason`, this.move_reason);
      
      if (window.location.pathname === "/admin/requests/duplicated") {
        body.append(`repeated_page`, '1');
      }

      this.selectedItems.length &&
        this.selectedItems.forEach((item, index) => {
          // body.append(`request_ids[${index}]`, item["id"]);
          console.log("req_itemKey" , this.req_itemKey);
          body.append(`request_ids[${index}]`, item[this.req_itemKey]);
        });
      this.$store.state.startElement.length &&
        this.$store.state.startElement.forEach((item, index) => {
          // body.append(`request_ids[${index}]`, item["id"]);
          console.log("req_itemKey" , this.req_itemKey);
          body.append(`request_ids[${index}]`, item[this.req_itemKey]);
        });

      axiosInstance
        .post(url, body)
        .then((res) => {
          this.active = true;
          this.message = res.data.message;
          this.color = "green";
          this.$emit("reloadPage");
          this.$store.state.reloaddata_after_action = {
                action: 'admin_all_requests',
                date: new Date,
                view_type: 'table',
              };
          this.move_reason = '';
          EventBus.$emit('EmptySelectedRequests');
        })
        .catch((err) => {
          this.active = true;
          let error = { err };
          let message = "";
          if (Array.isArray(error.err.response.data.message)) {
            message = error.err.response.data.message[0];
          } else {
            message = error.err.response.data.message;
          }
          this.message = message;
          this.color = "red";
        });
    },
  },
};
</script>
